/*
 * @Author: ckj kaijun.cui@biz-united.com.cn
 * @Date: 2025-12-31 15:46:58
 * @LastEditors: ckj kaijun.cui@biz-united.com.cn
 * @LastEditTime: 2025-12-31 15:49:14
 * @Description:
 */
import ImageViewer from './index.vue';

export default ImageViewer;
